import { Provider } from "react-redux";
import { createHashRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from "react-router-dom";

import { Page } from "@components";
import { Page as PageVolkstotal } from "../src-volkstotal/components";
import { NotificationsContainer } from "@rio-cloud/rio-uikit";
import screens from "@screens";
import screensVolkstotal from "../src-volkstotal/screens";
import { persistor, store } from "@store";
import { PersistGate } from "redux-persist/integration/react";
import { CoreProvider } from "./providers/CoreProvider";
import IntlWrapper from "./providers/IntlWrapper";
import PageTitle from "./components/PageTitle/index";

const routingRoutesFromElements = createRoutesFromElements(
  <>
    <Route element={<Page />}>
      <Route path="/" element={<Navigate to="/trucker-pay-gestor/dashboard" replace />} />
      <Route path="/trucker-pay-gestor/dashboard" element={<screens.DashboardScreen />} />
      <Route path="/trucker-pay-gestor/expenses" element={<screens.ExpensesScreen />} />
      <Route path="/trucker-pay-gestor/recipes" element={<screens.RecipesScreen />} />
      <Route path="/trucker-pay-gestor/fueling" element={<screens.FuelingScreen />} />
      <Route path="/trucker-pay-gestor/tolls" element={<screens.TollsScreen />} />
      <Route path="/trucker-pay-gestor/maintenance" element={<screens.MaintenanceScreen />} />
      <Route path="/trucker-pay-gestor/settings" element={<screens.SettingsPage />} />
    </Route>
    <Route element={<PageVolkstotal />}>
      <Route path="/volkstotal/dashboard" element={<screensVolkstotal.DashboardScreen />} />
      <Route path="/volkstotal/expenses" element={<screensVolkstotal.ExpensesScreen />} />
      <Route path="/volkstotal/recipes" element={<screensVolkstotal.RecipesScreen />} />
      <Route path="/volkstotal/settings" element={<screensVolkstotal.SettingsPage />} />
    </Route>
  </>
);

export const routingRouter = createHashRouter(routingRoutesFromElements);

const AppRouter = () => {
  return <RouterProvider router={routingRouter} />;
};

const App = () => {
  return (
    <CoreProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <IntlWrapper>
            <PageTitle />
            <NotificationsContainer />
            <AppRouter />
          </IntlWrapper>
        </PersistGate>
      </Provider>
    </CoreProvider>
  );
};

export default App;
